import React, { useState } from "react";
import { FaQuestionCircle, FaTimes } from "react-icons/fa";
import { useLocation } from "react-router-dom";

const Footer: React.FC = () => {
  const [isHelped, setIsHelped] = useState<boolean>(false);
  const location = useLocation();

  return (
    <div className="w-full mt-4 flex justify-end items-center">
      <div className="text-right text-sm text-gray-500 p-4">
        © New Vision – Center for Body Language – Developed by Patryk Wezowski &
        Kasia Wezowski
      </div>
      {location.pathname === "/" && (
        <div
          className="text-gray-600 cursor-pointer mr-3 text-xl"
          onClick={() => setIsHelped(true)}
        >
          <FaQuestionCircle />
        </div>
      )}
      {isHelped && (
        <div className="fixed top-0 bottom-0 left-0 right-0 bg-gray-800 bg-opacity-80 pt-8 px-8 z-[3000] text-white">
          <div className="bg-[#152034] p-4 relative text-base text-left md:w-[60%] mx-auto">
            <p className="text-center text-2xl mb-2 font-bold">Help</p>
            <p className="mb-2">
              Go in the Main menu and watch the Quick-start guide, where all
              instructions are explained in detail.
            </p>
            <p className="font-bold mb-2">
              You can replay videos only after a correct answer (or 3 times
              wrong) by hovering your mouse over bottom part of the video and
              clicking on the "Play" icon.
            </p>
            <p className="mb-3">
              Click on the "Fullscreen" button on the bottom right of the video
              When the solution is visible, you can also click on the
              "Fullscreen" button on the bottom right of the video window to
              show the video in full screen. Click the ESC key to go back to
              normal view.
            </p>
            <p className="">
              If you have any issues, please email us on
              support@microexpressionstrainingvideos.com
            </p>
            <div
              className="absolute top-2 right-2 cursor-pointer"
              onClick={() => setIsHelped(false)}
            >
              <FaTimes />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;
